"use client";

import { useEffect, useState } from "react";

export function readDocumentVisible(): boolean {
  if (typeof document === "undefined") {
    return true;
  }

  return document.visibilityState === "visible";
}

export function useDocumentVisible(): boolean {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(readDocumentVisible());

    const handleVisibilityChange = () => {
      setIsVisible(readDocumentVisible());
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  return isVisible;
}
